import { fail, success } from '@helpers/result-helper.js'
import toast from '@services/toasts/index.js'
import { isSuccess, isHttpStatus } from '@/helpers/http-status-helpers'

export default {
  namespaced: true,
  state: {
    loadingCount: 0,
    crudLoadingCount: 0,
  },
  getters: {
    moduleName: () => 'single-invoice',
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
  },
  actions: {
    async getInvoiceByInvoiceNo({ commit }, invoiceNo) {
      commit('START_LOADING')

      try {
        const response = await this.$api.invoices.getInvoiceByInvoiceNo(
          invoiceNo
        )

        if (isSuccess(response.status)) {
          return success(response.data)
        }
      } catch (ex) {
        if (isHttpStatus(ex.response.status, 'Forbidden')) {
          return fail(null, '', 403)
        }

        toast.error('Cannot load invoice')
        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
  },
}
